/* rb-m-nav.js — lift categories into the drawer, seed the search drawer.
   2026-09-11. Phone only. Depends on window.RBM (rb-m-core.js) and
   RBM.categories() (rb-m-home.js, which loads before this).

   The drawer is opened by Magnific Popup, which MOVES .mobile-draw out of its
   hidden home into .mfp-content and back again on close. The injection is
   done once against the element itself (it survives the move) and guarded by
   a data flag rather than re-run on every open. */
(function () {
  'use strict';
  if (!window.RBM) return;

  /* The logo at the top of the drawer is a CSS background-image on
     .drawer-nav__empty-banner -- it looks like a home link and is not one
     (Mark, 23 Sep: "tap the icon on the top to bring me back to the home
     page"). A real <a href="/"> is laid over the logo's footprint only, so
     the X (left) and Log in (right) are untouched. */
  RBM.onMobile('drawer-home', function () {
    RBM.when('.mobile-draw.js-menu-draw', 8000).then(function (draw) {
      var banner = draw && draw.querySelector('.drawer-nav__empty-banner');
      if (!banner || banner.querySelector('.rbm-draw-home')) return;
      var a = document.createElement('a');
      a.className = 'rbm-draw-home';
      a.href = '/';
      a.setAttribute('aria-label', 'Rooster Bus home');
      banner.appendChild(a);
    });
  });

  RBM.onMobile('drawer-cats', function () {
    RBM.when('.mobile-draw.js-menu-draw', 8000).then(function (draw) {
      if (!draw || draw.dataset.rbmCats === '1') return;

      var cats = (RBM.categories ? RBM.categories() : []);
      if (cats.length < 3) return;   /* menu not as expected — leave it alone */

      var wrapper = draw.querySelector('.mobile-draw__wrapper') || draw;
      var search = wrapper.querySelector('.mobile-draw__search');

      var label = document.createElement('div');
      label.className = 'rbm-draw-label';
      label.textContent = 'Shop by category';

      var grid = document.createElement('div');
      grid.className = 'rbm-draw-cats';
      cats.forEach(function (c) {
        var a = document.createElement('a');
        a.className = 'rbm-draw-cats__item' + (c.accent ? ' rbm-draw-cats__item--accent' : '');
        a.href = c.href;
        a.textContent = c.label;
        grid.appendChild(a);
      });
      /* an odd count leaves a hole in a 2-up grid — widen the last tile */
      if (cats.length % 2 === 1) grid.lastChild.classList.add('rbm-draw-cats__item--wide');

      if (search && search.nextSibling) {
        wrapper.insertBefore(label, search.nextSibling);
        wrapper.insertBefore(grid, label.nextSibling);
      } else {
        wrapper.insertBefore(label, wrapper.firstChild);
        wrapper.insertBefore(grid, label.nextSibling);
      }
      draw.dataset.rbmCats = '1';
    });
  });

  /* ---- search drawer: merchandised terms before the first keystroke -------
     The drawer shows an empty field and nothing else until you type. These
     are plain links to real collections, so nothing here depends on the
     predictive-search component's internals. */
  var POPULAR = [
    { label: 'Seager', href: '/collections/seager' },
    { label: 'Red Wing', href: '/collections/red-wing' },
    { label: 'Flannel', href: '/collections/long-sleeve-shirts-1' },
    { label: 'Denim', href: '/collections/denim' },
    { label: 'Hats', href: '/collections/hats' },
    { label: 'Gifts under $50', href: '/collections/gifts-for-him' }
  ];

  RBM.onMobile('search-suggest', function () {
    RBM.when('.search-draw.js-search-draw', 8000).then(function (draw) {
      if (!draw || draw.dataset.rbmSuggest === '1') return;
      var inner = draw.querySelector('.search__inner') || draw.querySelector('.search-draw__wrapper');
      if (!inner) return;

      var box = document.createElement('div');
      box.className = 'rbm-search-suggest';
      var lab = document.createElement('div');
      lab.className = 'rbm-search-suggest__label';
      lab.textContent = 'Popular right now';
      var hs = document.createElement('div');
      hs.className = 'rbm-hs';
      POPULAR.forEach(function (p) {
        var a = document.createElement('a');
        a.className = 'rbm-chip';
        a.href = p.href;
        a.textContent = p.label;
        hs.appendChild(a);
      });
      box.appendChild(lab);
      box.appendChild(hs);
      inner.appendChild(box);
      draw.dataset.rbmSuggest = '1';

      /* Hide as soon as they type so this never competes with real results. */
      var input = draw.querySelector('input[type="search"], input[type="text"]');
      if (input) {
        input.addEventListener('input', function () {
          box.style.display = input.value.trim() ? 'none' : '';
        });
      }
    });
  });
})();
